import type { CartProductInterface } from '@/types'

import { cartProductService } from './CartProductService'

export class CartSortingService {
  sortProducts(products: CartProductInterface[]): CartProductInterface[] {
    return [...products].sort((a, b) => {
      const aInfo = cartProductService.getQuantityInfo(a)
      const bInfo = cartProductService.getQuantityInfo(b)

      if (aInfo.isProblematic && !bInfo.isProblematic) return -1
      if (!aInfo.isProblematic && bInfo.isProblematic) return 1

      if (
        aInfo.originalIndex !== undefined &&
        bInfo.originalIndex !== undefined
      ) {
        return aInfo.originalIndex - bInfo.originalIndex
      }

      return (b.nomenclatureDto.code || 0) - (a.nomenclatureDto.code || 0)
    })
  }
  getRowClassName(
    product: CartProductInterface,
    highlightedProductId: string | null,
    noStockClass: string,
    highlightClass: string
  ): string {
    const { isProblematic } = cartProductService.getQuantityInfo(product)
    const key = cartProductService.getProductKey(product)

    let classes = ''

    if (isProblematic) {
      classes += ` ${noStockClass}`
    }

    if (highlightedProductId === key) {
      classes += ` ${highlightClass}`
    }

    return classes.trim()
  }
}

export const cartSortingService = new CartSortingService()
